// import Home from './spa/Example';

const ResourceIndex = r => require.ensure([], () => r(require('./pages/resourceIndex/resourceIndex.vue')));
const showResource = r => require.ensure([], () => r(require('./pages/showResource/showResource.vue')));
const showResourceImage = r => require.ensure([], () => r(require('./pages/showResource/showResourceImage.vue')));
import holder from './pages/holder/holder.vue';
// import About from './pages/About';
const editResource = r => require.ensure([], () => r(require('./pages/editResource/editResource.vue')));

const editResourceWrapper = r => require.ensure([], () => r(require('./pages/indexWrapper/editResourceWrapper.vue')));


const editProfile = r => require.ensure([], () => r(require('./pages/editProfile/editProfile.vue')));

// const camera = r => require.ensure([], () => r(require('./pages/camera/camera.vue')));
const chats = r => require.ensure([], () => r(require('./pages/conversations/chats.vue')));
const Messages = r => require.ensure([], () => r(require('./pages/messages/messages.vue')));
// import GroupsIndex from './pages/groupsIndex/groupsIndex.vue';
const GroupsIndex = r => require.ensure([], () => r(require('./pages/groupsIndex/groupsIndex.vue')));
const UserIndex = r => require.ensure([], () => r(require('./pages/user/userIndex.vue')));

const editGroup = r => require.ensure([], () => r(require('./pages/newGroup/editGroup.vue')));


// const createGroupHeader = r => require.ensure([], () => r(require('./pages/createGroupHeader/createGroupHeader.vue')));
const IndexWrapper = r => require.ensure([], () => r(require('./pages/indexWrapper/indexWrapper.vue')));

const Categories = r => require.ensure([], () => r(require('./components/categories.vue')));
const seenby = r => require.ensure([], () => r(require('./pages/seenby.vue')));

// import Auth from './pages/Auth.vue';
// import AuthSuccess from './pages/AuthSuccess.vue';


export const routes = [
  // { path: '/', component: editResource },
  // { path: '/', component: Categories },

  {
    path: '/',
    component: IndexWrapper,
    children: [
      { path: '/profile', name: 'show-current-user', component: UserIndex },
      { path: '/', name: 'root', component: ResourceIndex },
      { path: '/groups', name: 'groups', component: GroupsIndex },
      { path: '/chats', name: 'chats', component: chats },
    ]
  },

  {
    path: '/profile/:userId',
    component: UserIndex,
    name: 'show-user'
  },

  {
    path: '/categories',
    component: Categories,
    name: 'categories'
  },


  {
    path: '/chats/:destinationId/:resourceId',
    component: Messages,
    meta: { requiresAuth: true },
    name: 'messages'
  },



  {
    path: '/groups/:id/edit',
    name: 'edit-group',
    component: editGroup,
    meta: { requiresAuth: true }
  },


  // { path: '/', name: 'root', component: ResourceIndex },
  // { path: '/groups', component: GroupsIndex },
  // { path: '/chats', component: chats },
  // { path: '/', component: Messages },
  // { path: '/', component: IndexProfile },


  // { path: '/', component: Auth },
  // { path: '/auth', component: Auth },
  // { path: '/success', component: AuthSuccess },

  {
    path: '/resource',
    component: holder,
    children: [{
        path: ':resourceId',
        name: 'show-resource',
        component: showResource
      },
      {
        path: ':resourceId/image/:number',
        name: 'showResourceImage',
        component: showResourceImage,
      },
      {
        path: ':resourceId/edit',
        name: 'edit-resource-wrapper',
        component: editResourceWrapper,
        meta: { requiresAuth: true },
        children: [{
            path: '',
            name: 'edit-resource',
            component: editResource,
            meta: { requiresAuth: true }
          },
          {
            path: 'edit/categories',
            name: 'resource-categories',
            component: Categories,
            props: { resource: true }
          },
          {
            path: 'edit/offer/:index/seenby',
            name: 'resource-seenby',
            component: seenby,
          },
          {
            path: 'edit/offer/:index/seenby/newgroup',
            name: 'resource-seenby-newgroup',
            component: editGroup,
          }

        ]
      },

      // {
      //   path: 'new/edit',
      //   name: 'new-resource',
      //   component: editResource,
      //   meta: { requiresAuth: true }
      // },
      // {
      //   path: ':resourceId/edit/images',
      //   name: 'edit-resource-images',
      //   component: camera
      // },
    ]
  },

  // {
  //   path: '/camera',
  //   component: camera
  // },
  {
    path: '/edit',
    component: editResource
  },
  {
    path: '/editProfile',
    name: 'show-profile',
    component: editProfile,
    meta: { requiresAuth: true }
  },
  // { path: '/chats', component: chats },
  // {
  //   path: '/messages',
  //   component: Messages
  // },
  { path: '*', redirect: '/' },
];
